app.ui.registerUi('multifield', function (app) {
    //Email

    var helpers = app.helpers.funcs;

    return {
        implementationExists: function () {
            return true; // implementation is entirely encapsulated within this file.
        },
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
        init: function ($scope) {

            var $elems = helpers.resolveScope('[data-component=multifield-email]', $scope);
            if ($elems && $elems.length) {
                $elems.multifield({
                    selector: '[data-component=multifield-email]',
                    type: 'email',
                    label: $("[data-component='multifield-email']").data().label,
                    name: "teamMembers"
                });
            }
        }
    }

});

